
export interface CgiResp<T = any> {
  code: number;
  message: string;
  msg?: string;
  data: T;
}

export interface CgiTrpcResp<T = any> {
  ret: number;
  msg: string;
  data: T;
  code?: number
}

export enum CgiErrorCode {
  NO_ERROR = 0,
  NotLogin = 40001,
  NotBindPhone = 40002,
  NotQQLogin = 5002,
  /** 统一接入层失去登录态 */
  UniNotLogin = 15006,
  TrpcNtLogin = 20411,
  ErrLogin = 20409,
  NeedRefresh = 20447,

  // AI 资源限额
  BlackUser = 10021,
  UsageExceed = 10022,

  // 版本错误码
  VersionError = 10211,

  NOT_EXIST = 10302,
  // 素材部分操作失败
  MoveMaterialPartialFail = 10268,
  MoveMaterialAllFail = 10267,

  // 绘本 10501 - 10599
  DuplicateTask = 10501,
  DeleteByIdFail = 10504,

  // 前端业务错误码
  ValidateError = -100100100100,

  // 必填参数缺失
  SomeDataIsNull = 10205,

  // 邀请vuid不正确
  SomeDataIncorrect = 10234,

  // 无权限
  NoPermission = 10209,

  // 删除幕失败，请先删除剧情
  DeleteStageFail = 10102,

  // 删除章节失败，请先删除幕
  DeleteChapterFail = 10104,

  // 删除故事失败，请先删除章节
  DeleteStoryFail = 10101,

  // 删除角色失败，请先解除关联关系
  DeleteRoleFail = 10225,

  // 违规
  Illegal = 10023,
}

export const PIC_CODE_START = 10501;
export const PIC_CODE_END = 10599;
